import { mapGetters, mapActions } from "vuex";
import AppIcon from "@/components/AppIcon";
import AppTableHead from "@/components/AppTableHead";
import AppTd from "@/components/AppTd";
import AppButton from "@/components/AppButton";
import AppPageTitle from "@/components/AppPageTitle";
import ConnectionSuccess from "@/components/ConnectionSuccess";
import ConnectionFailed from "@/components/ConnectionFailed";
import { sortData } from "@/utils";
import { country_codes_flipped } from "@/utils/countries";
export default {
  name: "AmazonDSPAdsAccountSelectionPage",
  emits: ["close-ads-window", "back", "cancel", "select"],
  components: {
    AppTableHead,
    AppTd,
    AppButton,
    AppPageTitle,
    ConnectionSuccess,
    ConnectionFailed,
    AppIcon
  },
  data() {
    return {
      selectLimit: 10,
      loadingData: false,
      showSuccessMessage: false,
      showFailedMessage: false,
      authorizationFail: false,
      accounts: [],
      title: "Choose Amazon DSP Advertisers",
      errorTitle: "You have no access to any DSP Provider accounts",
      errorDetail: `We couldn’t find any DSP Provider accounts linked to your personnal Amazon user. <br/><br/>Please close this windows and restart the connection process with a user authorized on the Amazon DSP Account OR contact your account administrator to request access.`,
      supportText: "If you’re having trouble identifying the issue and need help, reach out to us for support.",
      successTitle: "All advertisers found for your DSP account are connected",
      successDetail: "You can now view and manage them directly in previous panel without any additional setup."
    };
  },
  async mounted() {
    var is_authenticated = await this.authStatus();
    this.loadingData = true;
    this.showSuccessMessage = false;
    this.showFailedMessage = false;
    if (is_authenticated) {
      //sessionStorage.setItem("useFaker", true);
      var result = await this.accountAuthorizeResultList();
      //sessionStorage.setItem("useFaker", false);
      //var result = await this.accountAuthorizeResultList();

      var accounts = result.filtered_profiles.length <= 0 ? result.unfiltered_profiles : result.filtered_profiles;
      accounts = accounts.filter(account => account.advertiserId);
      this.accounts = this.createaAccountList(accounts);
      this.showFailedMessage = result.filtered_profiles.length <= 0;
      this.authorizationFail = result.unfiltered_profiles.length <= 0;
      this.loadingData = false;
      this.selectAll(false);
    }
  },
  computed: {
    ...mapGetters(["getCountry", "getCountryCode", "getCountryFlag"]),
    selectedAccounts() {
      return this.accounts.filter(item => item.isSelected);
    },
    tableFields() {
      return [{
        key: "select",
        custom: "select-checkbox",
        isSelectAll: !this.showFailedMessage
      }, {
        key: "title",
        label: "Advertiser Name",
        custom: "product-wrapper"
      }, {
        key: "seller_id",
        label: "Advertiser Id",
        custom: "product-wrapper"
      }, {
        key: "account_id",
        label: "DSP Profiles",
        custom: "product-wrapper"
      }, {
        key: "country",
        label: "Country",
        custom: "product-wrapper"
      }];
    }
  },
  methods: {
    ...mapActions(["accountAuthorizeResultSelectedList", "accountAuthorizeResultList", "authStatus"]),
    onRowSelect(item) {
      if (this.selectedAccounts.length < this.selectLimit) {
        item.isSelected ??= false;
        item.isSelected = !item.isSelected;
        this.$emit("select", this.selectedAccounts);
      }
    },
    getFlagForMarketPlace(country) {
      return this.getCountryFlag(country);
    },
    createaAccountList(data) {
      let accountListFilter = [];
      data.forEach(account => {
        let singleAccount = {
          name: account.name,
          advertiserId: account.advertiserId,
          dspProfileName: account.amazon_dsp_profile_name,
          dspProfileId: account.amazon_dsp_profile_id,
          country: account.country
        };
        accountListFilter.push(singleAccount);
      });
      return sortData(accountListFilter, "name");
    },
    // onBack() {
    //   this.$emit("back");
    // },

    // onCancel() {
    //   this.$emit("cancel");
    // },

    async onValidate() {
      if (this.selectedAccounts.length) {
        //this.$emit("select", this.selectedAccounts);
        var result_update = await this.accountAuthorizeResultSelectedList({
          accounts: this.selectedAccounts.map(account => account.advertiserId)
        });
        if (result_update) {
          this.showSuccessMessage = true;
          return;
        }
        this.showFailedMessage = true;
        return;
      }
    },
    selectAll(val) {
      this.accounts.forEach(item => {
        item.isSelected ??= false;
        item.isSelected = val;
      });
      this.$emit("select", this.selectedAccounts);
    },
    flipCountry(country) {
      return country_codes_flipped[country];
    }
  }
};